// src/concluidasStore.js
// Pendências concluídas compartilhadas entre "Concluídas", "Dashboard", "Módulos" e "Calendário".
// Agora vêm da API (Firebird) através de dados.js.
import { useColecao, encerrarDados } from './dados';

export function useConcluidas() {
    const { dados, carregando, erro } = useColecao('concluidas');
    return { concluidas: dados, carregando, erro };
}

// mantido por compatibilidade com o App (logout)
export const encerrarConcluidas = () => encerrarDados();
